module.exports = __webpack_public_path__ + "static/payment_panel-9ec819efa63ccea9b23598dbf147d79d.png";